import React, { useEffect, useState } from 'react';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';
import {
  getViewAllLink,
  removeDuplicates,
  sortArrayResponseAsc,
} from '@common/Utility/common-utils';
import { flagsmith } from '@common/Lib/Flagsmith';
import InsiderRecCarousel from '@common/Component/InsiderRecommenderCarousel/InsiderRecCarousel';
import { useMemo } from 'react';
import { setInsiderObj } from 'Epharmacy/ProductDetails/redux/reducer';

const CommonProductCarousel = dynamic(() =>
  import('../../Common/Component/CommonProductCarousel/CommonProductCarousel'),
);

const NoResultFoundReCarousel = ({ facetResponse }) => {
  const dispatch = useDispatch();
  const [suggestedResponseData, setSuggestedResponseData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const insiderReducer = useSelector((state) => state?.app?.pdpReducer?.insider);
  const cartData = useSelector((state) => state?.epharmacy?.getCartDetails?.data);
  const ae_web_carousels = flagsmith.getValue('ae_web_carousels', { json: true });
  const router = useRouter();

  const productIds = useMemo(() => {
    let productId = '';
    if (cartData?.body?.delivery_groups) {
      cartData.body.delivery_groups.map((item, index) => {
        if (item?.sku) {
          productId += item.sku;
          if (index !== cartData.body.delivery_groups.length - 1) {
            productId += ',';
          }
        }
      });
    }
    return productId;
  }, [cartData?.body?.delivery_groups]);

  const suggestedProductCarousel = () => {
    if (facetResponse?.recommendationData?.data && facetResponse?.recommendationData?.data?.length > 0) {
      setSuggestedResponseData((prevState) => {
        const reResponse = [
          ...prevState,
          ...[{ ...facetResponse.recommendationData, position: 1, title: facetResponse.recommendationData.title }],
        ];
        return sortArrayResponseAsc(removeDuplicates(reResponse, 'position'), 'position');
      });
    } else {
      setSuggestedResponseData([]);
    }
  };

  useEffect(() => {
    suggestedProductCarousel();
  }, [facetResponse]);

  const checkInsider = () => {
    if (window.Insider) {
      window.Insider.eventManager.once('ins-sr:only-api-campaign:load', (event, data) => {
        const updatedInsiderObj = {};
        updatedInsiderObj[data?.campaignId] = data;
        window.insiderData = { ...window.insiderData, ...updatedInsiderObj }
        dispatch(setInsiderObj({
          insider: updatedInsiderObj
        }));
      });
    } else {
      setTimeout(checkInsider, 500);
    }
  };

  useEffect(() => {
    window.insiderData = {};
    checkInsider();
  }, [router?.pathname]);

  return (
    <>
      <div>
        {suggestedResponseData?.length > 0 &&
          suggestedResponseData?.map((ele) => (
            <CommonProductCarousel
              key={ele?.reOfferType}
              isLoading={isLoading}
              offerType={ele?.reOfferType}
              brandId={ele?.reOfferType || ele?.id}
              data={{ productList: ele }}
              title={ele?.title}
              showViewAllLink={ele?.showViewAll}
              viewAllLink={getViewAllLink(ele)}
            />
          ))}
      </div>
      <div>
        {ae_web_carousels?.carousels_config?.no_search_result?.map((data) => (
          <InsiderRecCarousel
            insiderRecommendation={data?.insiderRecommendation}
            variationId={data?.insiderRecommendation?.id}
            asterRecommendation={data?.asterRecommendation}
            productId={productIds}
            catId={''}
            insiderData={insiderReducer?.insider && insiderReducer?.insider[data?.insiderRecommendation?.id]}
          />
        ))}
      </div>
    </>
  );
};

export default NoResultFoundReCarousel;
